import { createActionGroup, props } from '@ngrx/store';
import { OrganizationEMR } from '@models/organizationEMR.model';

export const OrganizationEMRDetailsActions = createActionGroup({
  source: 'OrganizationEMRDetails',
  events: {
    'Update Organization EMR Details Failure': props<{ error: string }>(),
    'Is ACO Changed': props<{ value: number }>(),
    'Update Organization ACO Status Failure': props<{ error: string }>(),

    'Add Organization EMR': props<{ data: any }>(),
    'Add Organization EMR Success': props<{ data: OrganizationEMR }>(),
    'Add Organization EMR Failure': props<{ error: string }>(),
    'Add Organization EMR Conflict': props<{ message: string }>(),
  }
});
